import { render, staticRenderFns } from "./ChainsReadingEn.vue?vue&type=template&id=64196ece&lang=pug&"
import script from "./ChainsReadingEn.vue?vue&type=script&lang=js&"
export * from "./ChainsReadingEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports